import { render, staticRenderFns } from "./Accesso.vue?vue&type=template&id=610da4be&"
import script from "./Accesso.vue?vue&type=script&lang=js&"
export * from "./Accesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports